import { render } from "./CompanyInfo.vue?vue&type=template&id=3f050958&scoped=true&ts=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts"

import "./CompanyInfo.vue?vue&type=style&index=0&id=3f050958&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f050958"]])

export default __exports__